import { InjectionToken } from '@angular/core';

export const TemplateContextToken = new InjectionToken('template-context');
